"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PageContexts_1 = require("./Contexts/PageContexts");
const PageComponent = props => {
    const { component, controlPath, values, value, displayMap, defaultDateTimeFormat, forceOneLine, hidden } = props;
    const PageControl = (0, PageContexts_1.usePageControl)(component);
    return PageControl ? (react_1.default.createElement(PageControl, { forceOneLine: forceOneLine, defaultDateTimeFormat: defaultDateTimeFormat, displayMap: displayMap, value: value, values: values, controlDefinition: component, controlPath: controlPath || '', hidden: hidden })) : null;
};
exports.default = PageComponent;
